import UUID from '../UUID';
export default class {
  public constructor(readonly columnId: UUID, readonly rowId: UUID) {}
}
